import { Action } from '@ngrx/store';
import { Idefination, IMegaMenu, IProject, IProjectMenus, ISeoProjects } from './shell.state';

export enum WebsiteProjectsActionTypes {
    FETCH_DEFINATION = '[takeoff-website-projects] FETCH_DEFINATION',
    FETCH_DEFINATION_SUCCESS = '[takeoff-website-projects] FETCH_DEFINATION_SUCCESS',
    FETCH_DEFINATION_FAIL = '[takeoff-website-projects] FETCH_DEFINATION_FAIL',
    FETCH_MEGA_MENU = '[takeoff-website-projects] FETCH_MEGA_MENU',
    FETCH_MEGA_MENU_SUCCESS = '[takeoff-website-projects] FETCH_MEGA_MENU_SUCCESS',
    FETCH_MEGA_MENU_FAIL = '[takeoff-website-projects] FETCH_MEGA_MENU_FAIL',
    FETCH_WEBSITE_PROJECTS = '[takeoff-website-Projects] FETCH_WEBSITE_PROJECTS',
    FETCH_WEBSITE_PROJECTS_SUCCESS = '[takeoff-website-Projects] FETCH_WEBSITE_PROJECTS_SUCCESS',
    FETCH_WEBSITE_PROJECTS_FAIL = '[takeoff-website-Projects] FETCH_WEBSITE_PROJECTS_FAIL',
    FETCH_SEO_FILTERED_WEBSITE_PROJECTS = '[takeoff-website-Projects] FETCH_SEO_FILTERED_WEBSITE_PROJECTS',
    FETCH_SEO_FILTERED_WEBSITE_PROJECTS_SUCCESS = '[takeoff-website-Projects] FETCH_SEO_FILTERED_WEBSITE_PROJECTS_SUCCESS',
    FETCH_SEO_FILTERED_WEBSITE_PROJECTS_FAIL = '[takeoff-website-Projects] FETCH_SEO_FILTERED_WEBSITE_PROJECTS_FAIL',
    FETCH_SEO_FILTERED_WEBSITE_PROJECT = '[takeoff-website-Projects] FETCH_SEO_FILTERED_WEBSITE_PROJECT',
    FETCH_SEO_FILTERED_WEBSITE_PROJECT_SUCCESS = '[takeoff-website-Projects] FETCH_SEO_FILTERED_WEBSITE_PROJECT_SUCCESS',
    FETCH_SEO_FILTERED_WEBSITE_PROJECT_FAIL = '[takeoff-website-Projects] FETCH_SEO_FILTERED_WEBSITE_PROJECT_FAIL',
    FETCH_WEBSITE_LATEST_PROJECTS = '[takeoff-website-Projects] FETCH_WEBSITE_LATEST_PROJECTS',
    FETCH_WEBSITE_LATEST_PROJECTS_SUCCESS = '[takeoff-website-Projects] FETCH_WEBSITE_LATEST_PROJECTS_SUCCESS',
    FETCH_WEBSITE_LATEST_PROJECTS_FAIL = '[takeoff-website-Projects] FETCH_WEBSITE_LATEST_PROJECTS_FAIL',
    FETCH_ALL_PROJECTS = '[takeoff-website-projects] FETCH_ALL_PROJECTS',
    FETCH_ALL_PROJECTS_SUCCESS = '[takeoff-website-projects] FETCH_ALL_PROJECTS_SUCCESS',
    FETCH_ALL_PROJECTS_FAIL = '[takeoff-website-projects] FETCH_ALL_PROJECTS_FAIL',
    FETCH_WEBSITE_PROJECT_MENUS = '[takeoff-website-Projects] FETCH_PROJECT_MENUS',
    FETCH_WEBSITE_PROJECT_MENUS_SUCCESS = '[takeoff-website-Projects] FETCH_PROJECT_MENUS_SUCCESS',
    FETCH_WEBSITE_PROJECT_MENUS_FAIL = '[takeoff-website-Projects] FETCH_PROJECT_MENUS_FAIL',
    SET_STUDENT_DETAILS = '[takeoff-website-Projects] SET_STUDENT_DETAILS',
};

export class FETCH_DEFINATION implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_DEFINATION;
}

export class FETCH_DEFINATION_SUCCESS implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_DEFINATION_SUCCESS;

    constructor(public payload: Idefination) { }
}

export class FETCH_DEFINATION_FAIL implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_DEFINATION_FAIL;

    constructor(public payload: any) { }
}

export class FETCH_MEGA_MENU implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_MEGA_MENU;
}

export class FETCH_MEGA_MENU_SUCCESS implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_MEGA_MENU_SUCCESS;

    constructor(public payload: IMegaMenu) { }
}

export class FETCH_MEGA_MENU_FAIL implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_MEGA_MENU_FAIL;

    constructor(public payload: any) { }
}

export class FETCH_WEBSITE_PROJECTS implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_WEBSITE_PROJECTS;
}

export class FETCH_WEBSITE_PROJECTS_SUCCESS implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_WEBSITE_PROJECTS_SUCCESS;

    constructor(public payload: IProject[]) { }
}

export class FETCH_WEBSITE_PROJECTS_FAIL implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_WEBSITE_PROJECTS_FAIL;

    constructor(public payload: any) { }
}

export class FETCH_SEO_FILTERED_WEBSITE_PROJECTS implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_SEO_FILTERED_WEBSITE_PROJECTS;

    constructor(public payload: any) { }
}

export class FETCH_SEO_FILTERED_WEBSITE_PROJECTS_SUCCESS implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_SEO_FILTERED_WEBSITE_PROJECTS_SUCCESS;

    constructor(public payload: ISeoProjects[]) { }
}

export class FETCH_SEO_FILTERED_WEBSITE_PROJECTS_FAIL implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_SEO_FILTERED_WEBSITE_PROJECTS_FAIL;

    constructor(public payload: any) { }
}

export class FETCH_SEO_FILTERED_WEBSITE_PROJECT implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_SEO_FILTERED_WEBSITE_PROJECT;

    constructor(public payload: any) { }
}

export class FETCH_SEO_FILTERED_WEBSITE_PROJECT_SUCCESS implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_SEO_FILTERED_WEBSITE_PROJECT_SUCCESS;

    constructor(public payload: any) { }
}

export class FETCH_SEO_FILTERED_WEBSITE_PROJECT_FAIL implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_SEO_FILTERED_WEBSITE_PROJECT_FAIL;

    constructor(public payload: any) { }
}

export class FETCH_WEBSITE_LATEST_PROJECTS implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_WEBSITE_LATEST_PROJECTS;
    constructor(public payload: any) { }
}

export class FETCH_WEBSITE_LATEST_PROJECTS_SUCCESS implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_WEBSITE_LATEST_PROJECTS_SUCCESS;

    constructor(public payload: IProject[]) { }
}

export class FETCH_WEBSITE_LATEST_PROJECTS_FAIL implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_WEBSITE_LATEST_PROJECTS_FAIL;

    constructor(public payload: any) { }
}

export class FETCH_ALL_PROJECTS implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_ALL_PROJECTS;

    constructor(public payload: any) { }
}

export class FETCH_ALL_PROJECTS_SUCCESS implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_ALL_PROJECTS_SUCCESS;

    constructor(public payload: IProject[]) { }
}

export class FETCH_ALL_PROJECTS_FAIL implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_ALL_PROJECTS_FAIL;

    constructor(public payload: any) { }
}

export class FETCH_WEBSITE_PROJECT_MENUS implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_WEBSITE_PROJECT_MENUS;
}

export class FETCH_WEBSITE_PROJECT_MENUS_SUCCESS implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_WEBSITE_PROJECT_MENUS_SUCCESS;

    constructor(public payload: IProjectMenus[]) { }
}

export class FETCH_WEBSITE_PROJECT_MENUS_FAIL implements Action {
    readonly type = WebsiteProjectsActionTypes.FETCH_WEBSITE_PROJECT_MENUS_FAIL;

    constructor(public payload: any) { }
}

export class SET_STUDENT_DETAILS implements Action {
    readonly type = WebsiteProjectsActionTypes.SET_STUDENT_DETAILS;

    constructor(public payload: any) { }
}

export type WebsiteProjectsActions = | FETCH_MEGA_MENU
    | FETCH_MEGA_MENU_SUCCESS
    | FETCH_MEGA_MENU_FAIL
    | FETCH_DEFINATION
    | FETCH_DEFINATION_SUCCESS
    | FETCH_DEFINATION_FAIL
    | FETCH_WEBSITE_PROJECTS
    | FETCH_WEBSITE_PROJECTS_SUCCESS
    | FETCH_WEBSITE_PROJECTS_FAIL
    | FETCH_SEO_FILTERED_WEBSITE_PROJECTS
    | FETCH_SEO_FILTERED_WEBSITE_PROJECTS_SUCCESS
    | FETCH_SEO_FILTERED_WEBSITE_PROJECTS_FAIL
    | FETCH_SEO_FILTERED_WEBSITE_PROJECT
    | FETCH_SEO_FILTERED_WEBSITE_PROJECT_SUCCESS
    | FETCH_SEO_FILTERED_WEBSITE_PROJECT_FAIL
    | FETCH_WEBSITE_LATEST_PROJECTS
    | FETCH_WEBSITE_LATEST_PROJECTS_SUCCESS
    | FETCH_WEBSITE_LATEST_PROJECTS_FAIL
    | FETCH_ALL_PROJECTS
    | FETCH_ALL_PROJECTS_SUCCESS
    | FETCH_ALL_PROJECTS_FAIL
    | FETCH_WEBSITE_PROJECT_MENUS
    | FETCH_WEBSITE_PROJECT_MENUS_SUCCESS
    | FETCH_WEBSITE_PROJECT_MENUS_FAIL
    | SET_STUDENT_DETAILS;